exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.newsBox[data-v-08e3cd88] {\n    margin-top: 10px;\n}\n.newsBox .leftBox[data-v-08e3cd88] {\n      display: none;\n}\n.newsBox .rightBox[data-v-08e3cd88] {\n      display: block;\n      width: auto;\n      margin: 0 10px;\n}\n}\n", ""]);

